import { render, staticRenderFns } from "./bwg_manage.vue?vue&type=template&id=01d66f4b&"
import script from "./bwg_manage.vue?vue&type=script&lang=js&"
export * from "./bwg_manage.vue?vue&type=script&lang=js&"
import style0 from "./bwg_manage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports